export default __webpack_public_path__ + "static/media/nelWhiteBorder.a718ec99.svg";